import { Row, Col, Container } from "react-bootstrap";

import "./style.css";

const LogoFull = "/assets/img/logo-full.png";
const paymentPrefix = "/assets/img/bank";
const courierPrefix = "/assets/img/couriers";
const socialPrefix = "/assets/img/social-media";

const courierList = ["jne", "jet", "lion", "pos", "tiki"];
const socialList = ["facebook", "instagram", "twitter", "tiktok"];
const paymentList = ["mandiri", "permata", "bni", "bri", "bca", "gopay", "ovo"];

let year = new Date();
year = year.getFullYear();

const FooterContainer = () => {
  return (
    <>
      <footer className="border-top">
        <Row id="id-footer" className="justify-content-around mb-0 pt-2 pb-0 mx-0">
          <Col sm={12} md={12} lg={11}>
            <Container>
              <Row className="justify-content-center">
                <div className="col-md-12 col-lg-3 col-12 font-italic align-items-center mt-md-3 mt-4">
                  <h5>
                    <img src={LogoFull} width="160" alt="logo" />
                  </h5>

                  <div className="social mt-3 mb-3">
                    {socialList.map((data) => (
                      <img
                        key={data}
                        width={25}
                        height={25}
                        src={`${socialPrefix}/${data}.png`}
                        className="social-img"
                        alt="social-media"
                      />
                    ))}
                  </div>

                  <br />
                  <small className="copy-rights cursor-pointer">
                    Ⓒ {year} Karma Yadnya Nadhi Dekorasi
                  </small>
                  <br />
                  <small>All Right Reserved</small>
                </div>

                <div className="col-md-12 col-lg-3 col-12 my-0">
                  <ul className="list-unstyled">
                    <li className="mt-md-3 mt-4">Kontak Kami</li>
                    <li>
                      <i className="fab fa-whatsapp me-2 fs-18" />
                      +628113885929
                    </li>
                    <li>
                      <i className="far fa-envelope me-2" />
                      support@karmayadnya.id
                    </li>
                    <li>
                      Jl. Muding Tengah, Bougenville No. 18 Kerobokan, Kuta Utara, Badung, Bali
                      80361
                    </li>
                  </ul>
                </div>

                <div className="col-md-12 col-lg-3 col-12 my-sm-0 mt-5 mt-0-s">
                  <ul className="list-unstyled ml-5 ml-0-s">
                    <li className="mt-md-3 mt-4">Informasi</li>
                    <li>Tentang Kami</li>
                    <li>Panduan Belanja</li>
                    <li>Syarat & Ketentuan</li>
                    <li>Kebijakan Privasi</li>
                  </ul>
                </div>

                <div className="col-md-12 col-lg-3 col-12 my-sm-0 mt-5 mt-0-s">
                  <ul className="list-unstyled multi-bank">
                    <li className="mt-md-3 mt-4 mb-2">Metode Pembayaran</li>
                    <div className="img-bank">
                      {paymentList.map((data) => (
                        <img
                          key={data}
                          width={48}
                          height={48}
                          src={`${paymentPrefix}/${data}.png`}
                          className="payment-info"
                          alt="payment-info"
                        />
                      ))}
                    </div>
                  </ul>
                  <ul className="list-unstyled multi-bank">
                    <li className="mt-md-3 mt-4 mb-2">Metode Pengiriman</li>
                    <div className="img-bank">
                      {courierList.map((data) => (
                        <img
                          key={data}
                          width={70}
                          height={36}
                          src={`${courierPrefix}/${data}.png`}
                          className="couriers-info"
                          alt="couriers-info"
                        />
                      ))}
                    </div>
                  </ul>
                </div>
              </Row>
            </Container>
          </Col>
        </Row>
      </footer>
    </>
  );
};

export default FooterContainer;
